import { render, staticRenderFns } from "./MetricModule.vue?vue&type=template&id=4d627150"
import script from "./MetricModule.vue?vue&type=script&lang=js"
export * from "./MetricModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports